export const CONTROL_BAR_HEIGHT = 48;
